import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1159b926"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade bgModalCancelada",
  id: "citaCanceladaModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "detalleCitaCanceladaModalRef",
  tabindex: "-2",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-450px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header pt-5 pb-3 px-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-left fs-2 fw-bold" }, "Cita cancelada")
], -1))
const _hoisted_5 = { class: "modal-body scroll-y px-10" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-12 text-start" }
const _hoisted_8 = { class: "p-0 lst-none" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-base fw-bold" }, [
    /*#__PURE__*/_createTextVNode("Comentarios"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " *")
  ])
], -1))
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = { class: "col-12 text-center" }
const _hoisted_12 = { class: "lst-none inFlex ps-0" }
const _hoisted_13 = { class: "me-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Descartar", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Guardar resultados")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loaderClientVue = _resolveComponent("loaderClientVue")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_loaderClientVue, { showLoader: _ctx.loading }, null, 8, ["showLoader"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            onSubmit: _ctx.sendData,
            "validation-schema": _ctx.validation,
            novalidate: "novalidate"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("ul", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("li", null, [
                      _createVNode(_component_Field, {
                        name: "comment",
                        ref: "comment",
                        modelValue: _ctx.formData.comment,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.comment) = $event)),
                        as: "textarea",
                        class: "form-control form-control-sm fs-base form-control-solid borderGray",
                        rows: "3"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "comment"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("ul", _hoisted_12, [
                    _createElementVNode("li", _hoisted_13, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeCancelada && _ctx.closeCancelada(...args))),
                        "data-bs-dismiss": "modal"
                      }, _hoisted_15)
                    ]),
                    _hoisted_16
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}